import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const WashingMachineIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "WashingMachineIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M19.8955 2.25269H5.00473C4.66224 2.25269 4.38428 2.53065 4.38428 2.87314V21.4867C4.38428 21.8292 4.66224 22.1071 5.00473 22.1071H19.8955C20.238 22.1071 20.516 21.8292 20.516 21.4867V6.65799C20.516 6.3155 20.238 6.03754 19.8955 6.03754C19.5531 6.03754 19.2751 6.3155 19.2751 6.65799V20.8662H5.62518V8.45719H19.8955C20.238 8.45719 20.516 8.17923 20.516 7.83674V2.87314C20.516 2.53065 20.238 2.25269 19.8955 2.25269ZM5.62518 3.49359H19.2751V7.2163H5.62518V3.49359Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M8.10698 14.6617C8.10698 17.0566 10.0552 19.0049 12.4501 19.0049C14.8451 19.0049 16.7933 17.0566 16.7933 14.6617C16.7933 12.2668 14.8451 10.3185 12.4501 10.3185C10.0552 10.3185 8.10698 12.2668 8.10698 14.6617ZM15.5524 14.6617C15.5524 16.3723 14.1607 17.7639 12.4501 17.7639C10.7396 17.7639 9.34789 16.3723 9.34789 14.6617C9.34789 12.9511 10.7396 11.5594 12.4501 11.5594C14.1607 11.5594 15.5524 12.9511 15.5524 14.6617Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M17.4137 4.73449H12.4501C12.1076 4.73449 11.8297 5.01245 11.8297 5.35494C11.8297 5.69743 12.1076 5.97539 12.4501 5.97539H17.4137C17.7562 5.97539 18.0342 5.69743 18.0342 5.35494C18.0342 5.01245 17.7562 4.73449 17.4137 4.73449Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M9.96834 5.97849C10.3127 5.97849 10.5919 5.69931 10.5919 5.35494C10.5919 5.01056 10.3127 4.73139 9.96834 4.73139C9.62396 4.73139 9.34479 5.01056 9.34479 5.35494C9.34479 5.69931 9.62396 5.97849 9.96834 5.97849Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
      <path
        d="M7.48653 5.97849C7.8309 5.97849 8.11008 5.69931 8.11008 5.35494C8.11008 5.01056 7.8309 4.73139 7.48653 4.73139C7.14215 4.73139 6.86298 5.01056 6.86298 5.35494C6.86298 5.69931 7.14215 5.97849 7.48653 5.97849Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default WashingMachineIcon;
